var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { FakeRestResult } from "@ane/core/lib/services/FakeRestResult";
import EnvironmentService, { AZURE_TEST_WORKSPACE_ID } from "@ane/core/lib/services/EnvironmentService";
class AzureResources extends RestServiceBase {
  constructor() {
    super(
      {
        url: "https://management.azure.com/providers/Microsoft.ResourceGraph",
        tokenScope: "https://management.azure.com/.default"
      },
      "/resources?api-version=2019-04-01"
    );
  }
  getWorkspaces() {
    return __async(this, null, function* () {
      var _a;
      const data = {
        query: "",
        subscriptions: ["dad45786-32e5-4ef3-b90e-8e0838fbadb6"]
      };
      const queryparams = EnvironmentService.getUnescapedQueryParams();
      const source = (_a = queryparams.workspaceSource) != null ? _a : null;
      if (source === "arm") {
        return yield this._post(data, "");
      } else {
        const restResult = new FakeRestResult(azureResourceStaticData(source), "");
        return new Promise((resolve) => resolve(restResult));
      }
    });
  }
}
const azureResourceStaticData = (source = "") => {
  const result = {
    data: {
      columns: [
        {
          name: "tokenScope",
          type: "string"
        },
        {
          name: "workspaceId",
          type: "object"
        },
        {
          name: "subscriptionId",
          type: "string"
        },
        {
          name: "resourceGroup",
          type: "string"
        },
        {
          name: "name",
          type: "string"
        }
      ],
      rows: [
        [
          "/subscriptions/dad45786-32e5-4ef3-b90e-8e0838fbadb6/resourceGroups/msft-experimentation-prod-rg/providers/Microsoft.Experimentation/experimentWorkspaces/msft",
          "a5766fee-9478-488b-9fc0-64d1ad72c290",
          "dad45786-32e5-4ef3-b90e-8e0838fbadb6",
          "msft-experimentation-prod-rg",
          "msft"
        ]
      ]
    }
  };
  if (source === "includevnext") {
    const azureExpTest = [
      "/subscriptions/dad45786-32e5-4ef3-b90e-8e0838fbadb6/resourceGroups/expapi-prod-rg/providers/Microsoft.Experimentation/experimentWorkspaces/azureexptest",
      AZURE_TEST_WORKSPACE_ID,
      "dad45786-32e5-4ef3-b90e-8e0838fbadb6",
      "expapi-prod-rg",
      "azureexptest"
    ];
    result.data.rows.push(azureExpTest);
  }
  return result;
};
const AzureResources$1 = new AzureResources();
export {
  AzureResources,
  azureResourceStaticData,
  AzureResources$1 as default
};
//# sourceMappingURL=AzureResources.js.map
